export function applyGrayscaleFilter(obj={}){

	/**** 
	 * canvasElement - AN INSTANCE OF canvas.getContext(2d);
	 * grayscalePercentage - HOW MUCH GRAYSCALE SHOULD BE APPLIED
	 * ****/

	const canvasContext = obj.canvasContext;
	const grayscalePercentage = obj.percentage;

	canvasContext.filter = `grayscale(${grayscalePercentage}%)`;


};